import { render, staticRenderFns } from "./section-footer.vue?vue&type=template&id=168bd988&"
import script from "./section-footer.vue?vue&type=script&lang=js&"
export * from "./section-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports